import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../../colors';

export const useStyles = makeStyles({
  wrapper: props => ({
    display: 'flex',
    flexDirection: 'column',
    width: props.expanded ? '300px' : '100px',
    minWidth: props.expanded ? '300px' : '100px',
    borderRight: `1px solid ${colors.neutral100}`,
    backgroundColor: colors.neutral25,
    transition: 'width 0.4s ease-in-out',
  }),
  collapseArea: props => ({
    padding: '20px 38px',
  }),
  collapseButton: {
    display: 'flex',
    cursor: 'pointer',
  },
  stepsContainer: props => ({
    flex: 1,
    overflowY: 'auto',
    position: 'relative',
    paddingTop: props.expanded ? 0 : '8px',
  }),
  mainSection: props => ({
    padding: props.expanded ? '8px 12px' : '12px 12px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '8px',
    cursor: 'pointer',
    justifyContent: props.expanded ? 'flex-start' : 'center',
    borderRadius: '6px',
    margin: props.expanded ? '4px 24px' : '0 24px',
    '&:hover': {
      backgroundColor: props.expanded ? colors.primary100 : 'transparent',
    },
  }),
  sectionHighlight: {
    backgroundColor: colors.primary100,
  },
  subsection: props => ({
    padding: props.expanded ? '8px 12px 8px 24px' : '8px 12px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '8px',
    cursor: 'pointer',
    justifyContent: props.expanded ? 'flex-start' : 'center',
    borderRadius: '6px',
    margin: '4px 24px',
    fontSize: '14px',
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontWeight: 400,
    lineHeight: '20px',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: colors.primary50,
    },
  }),
  dctName: ({ expanded }) => ({
    padding: expanded ? '8px 24px 8px 40px' : '8px 12px',
    textAlign: expanded ? 'left' : 'center',
    margin: '4px 24px',
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    cursor: 'pointer',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderRadius: '6px',
    '&:hover': {
      backgroundColor: colors.primary50,
    },
  }),
  subsectionSelected: {
    backgroundColor: colors.primary50,
    fontWeight: '600 !important',
    color: `${colors.primary600} !important`,
  },
  subsectionTextHighlight: {
    fontWeight: '600 !important',
    color: `${colors.primary600} !important`,
  },
  sectionCount: {
    color: colors.primary200,
    textAlign: 'center',
    fontSize: '12px',
    borderRadius: '50%',
    border: `2px solid ${colors.primary200}`,
    fontWeight: 600,
    lineHeight: '16px',
    height: '24px',
    width: '24px',
    minWidth: '24px',
    minHeight: '24px',
    alignContent: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '4px',
      backgroundColor: colors.primary200,
      left: '50%',
      top: '110%',
      height: '24px',
      transform: 'translateX(-50%)',
    },
  },
  sectionSelected: {
    border: `2px solid ${colors.primary500}`,
    color: colors.primary500,
    fontWeight: 700,
  },
  sectionCompleted: {
    border: `2px solid ${colors.primary500}`,
    color: colors.primary500,
    fontWeight: 700,
  },
  sectionTitle: ({ expanded }) => ({
    color: colors.neutral700,
    fontFamily: 'Manrope',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    opacity: expanded ? 1 : 0,
    transition: 'opacity 0.2s ease-in-out',
  }),
  sectionTitleSelected: {
    color: `${colors.primary500} !important`,
    fontWeight: '700 !important',
  },
  memberActionsWrapper: props => ({
    padding: `24px 16px`,
    display: 'flex',
    flexDirection: props.expanded ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  }),
  actionBtn: {
    padding: 0,
    borderRadius: '4px',
    minWidth: '40px !important',
    width: '40px !important',
    height: '40px !important',
    '& svg': {
      width: '16px',
      height: '16px',
    }
  },
  profileBtn: {
    border: `1px solid ${colors.primary500}`,
    color: colors.primary500,
    '& svg': {
      '& path': {
        fill: colors.primary500,
      },
    },
    '&:hover': {
      backgroundColor: colors.primary100,
    }
  },
  amaBtn: {
    border: `1px solid ${colors.secondary500}`,
    color: colors.secondary500,
    '& svg': {
      '& path': {
        fill: colors.secondary500,
      },
    },
    '&:hover': {
      backgroundColor: colors.secondary100,
    }
  },
  apptBtn: {
    border: `1px solid ${colors.green500}`,
    color: colors.green500,
    '& svg': {
      '& path': {
        fill: colors.green500,
      },
    },
    '&:hover': {
      backgroundColor: colors.green50,
    }
  },
  chatBtn: {
    border: `1px solid ${colors.orange500}`,
    color: colors.warning500,
    '& svg': {
      '& path': {
        fill: colors.warning500,
      },
    },

    '&:hover': {
      backgroundColor: colors.warning100,
    }
  },
  evaluationContainer: props => ({
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
  }),
  collapsedDot: {
    zIndex: 1,
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: colors.primary200,
    margin: '12px auto',
    position: 'relative',
    cursor: 'pointer',
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '4px',
      backgroundColor: colors.primary200,
      left: '50%',
      top: '100%',
      height: '24px',
      transform: 'translateX(-50%)',
    },
  },
  collapsedDotActive: {
    backgroundColor: colors.primary500,
  },
  collapsedDotLast: {
    '&::after': {
      display: 'none',
    },
  },
  sectionCountFirst: {
    marginTop: 0,
  },
  sectionCountLast: {
    '&::after': {
      display: 'none',
    },
  },
});
